import { LoyaltyChallengeConfig } from '@shared/models';

import {
  DISPLAY_CONDITION,
  NavbarItemLocation,
  NixSubType,
  ProductCheckTabType,
  RewardFormat,
  SubType,
  TitleType,
  Variants,
} from '../utils';

export const NIX_CONFIG: LoyaltyChallengeConfig = {
  currency: 'EUR',
  appIcon: 'assets/images/nix/favicon.ico',
  dialogVerticalOffset: -220,
  cssVariables: {
    'font-family': 'WorksSan-Regular',
    'font-family-medium': 'WorksSan-Medium',
    'font-family-semi-bold': 'WorksSan-SemiBold',
    'font-family-bold': 'WorksSan-Bold',

    'navbar-height': '75px',
    'navbar-background-color': 'white',

    'nav-link-color': '#737373',
    'nav-link-active-color': '#0710AC',

    'nav-item-bg-color': 'white',
    'nav-item-active-bg-color': 'white',
    'nav-item-hover-bg-color': 'rgb(0 0 0 / 10%)',
    'nav-item-font-family': 'var(--font-family-semi-bold)',

    'body-color': '#000000',
    'body-background-color': '#ffffff',

    'challenge-primary-color': '#0710AC',
    'tooltip-text-color': 'white',
    'tooltip-background-color': 'black',
  },
  rewardFormat: RewardFormat.PRICE,
  og: {
    title: 'Défis Picard | Picard',
    description:
      "Participez aux défis Picard et gagnez des bons d'achat à valoir sur tous les produits Picard dans les magasins Picard en France métropolitaine, Belgique et Luxembourg et sur le site internet www.picard.fr.",
  },
  rewardTemplate: '{points}<span style="font-size: 14px;"></span>',
  pages: {
    availablePages: ['current', 'help'],
    help: {
      meta: {
        title: 'Défis Picard | Picard | Aide',
        keywords:
          "picard, surgelés, défis, challenge, gagner, bon d'achat, fidélité, picard&nous, Comment ça marche, FAQ",
        description:
          "Participez aux défis Picard et gagnez des bons d'achat à valoir sur tous les produits Picard dans les magasins Picard en France métropolitaine, Belgique et Luxembourg et sur le site internet www.picard.fr.",
      },
      header: {
        background: '#F2F3FB',
        bannerAlternativeText: '',
        goBackButton: {
          text: 'Retour à mes défis',
          backgroundColor: '#0710AC',
          color: 'white',
          fontFamily: 'var(--font-family)',
          borderRadius: '5px',
        },
        howToPlay: {
          specificDisplayCondition: DISPLAY_CONDITION.ALWAYS,
          title: {
            color: '#0710AC',
            text: 'Comment ça marche ?',
            fontFamily: 'var(--font-family-semi-bold)',
          },
          templateHowToPlay: {
            mobile: [
              '<div style="text-align: center; font-size: 5.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
              '* sous la forme de coupons',
              '</div>',
            ],
            tablet: [
              '<div style="text-align: center; font-size: 2.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
              '* sous la forme de coupons',
              '</div>',
            ],
            desktop: [
              '<div style="text-align: center; font-size: 1.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
              '* sous la forme de coupons',
              '</div>',
            ],
          },
        },
      },
      faqVariant: {
        variant: Variants.VARIANT_1,
        title: {
          displayWhenCampaignBis: false,
          type: TitleType.TEXT,
          label: 'Foire aux questions',
          styles: {
            color: '#0710AC',
            fontSize: '25px',
            fontFamily: 'var(--font-family-semi-bold)',
          },
        },
        questions: [
          {
            title: 'Suis-je obligé de sélectionner 6 défis ?',
            content:
              'Vous pouvez relever autant de défis que vous voulez ! Vous ne pourrez juste en choisir plus de 6 sur 10.',
          },
          {
            title: 'Est-ce que je peux changer de défi ?',
            content:
              'Vous pouvez changer d’avis et de défi seulement jusqu’à votre premier passage en caisse ou votre première commande en ligne. Une fois que vous avez commencé à cumuler des achats sur un défi, vous ne pouvez plus le modifier.',
          },
          {
            title:
              'Si je dépasse mon objectif d’achat sur un défi, est-ce que je continue à augmenter ma cagnotte ?',
            content:
              'Dès lors que vous avez atteint le  3e palier sur un défi, vous sécurisez le gain associé sur votre cagnotte ! Après l’atteinte du  3e palier du défi, chaque achat supplémentaire ne fera pas croître votre cagnotte car le gain est limité à l’atteinte du  3e palier.',
          },
          {
            title:
              'Puis-je cumuler mes achats entre différents magasins et sur picard.fr ?',
            content:
              'Oui, tous vos achats comptent tant que vous présentez votre carte de fidélité à chaque achat. Vous faites progresser vos défis à chacun de vos achats dans les magasins Picard et sur picard.fr ou l’application mobile.',
          },
          {
            title: 'Comment se calcule ma cagnotte Mes Défis Picard & Nous ?',
            content:
              'A chaque défi gagné, vous cumulez des euros sur votre cagnotte jusqu’à la fin de la période de jeu.',
          },
          {
            title:
              'Est-ce que mes commandes web en livraison à domicile ou click&collect sont comptabilisées ?',
            content:
              'Oui tout à fait tous vos achats sont pris en compte, qu’ils soient en magasin, sur le web ou l’application mobile. Vos commandes en ligne seront comptabilisées à J+1 après votre livraison. Toute commande livrée à l’issue de la période du jeu, ne sera pas prise en compte dans le cadre des Défis. ',
          },
          {
            title:
              'Puis-je cumuler « Mes Défis Picard & Nous » avec d’autres réductions ?',
            content:
              'Oui, les défis sont cumulables avec la plupart des promotions. En cas de promotions ou de passage de coupons de remises, c’est le montant restant qui sera pris en compte dans le compteur du défi.<br/>Le montant utilisé pour la progression de vos défis est le montant restant une fois toutes les remises, promotions et coupons de remises déduits.',
          },
          {
            title: 'Comment suivre l’avancement de mes défis ?',
            content:
              'Votre page personnelle avec vos défis est mise à jour dans un délai de 24h à 72h après chaque achat en magasin ou suivant le jour de livraison de votre commande en ligne. Une barre d’avancement indiquera la progression de chacun de vos défis jusqu’à la fin de l’opération. Vous pouvez la retrouver dans la rubrique « Mes défis » dans votre compte client sur picard.fr ou l’application mobile.',
          },
          {
            title:
              'Quand est-ce que mes coupons “mes défis” seront disponibles ?',
            content:
              'Le montant que vous avez cagnotté durant l’opération est versé sous forme de coupons. Dans les 10 jours après la fin du jeu, vous recevrez par mail vos coupons qui seront ensuite utilisables en magasin, sur notre site <a href="https://www.picard.fr/" target="_blank" rel="noopener noreferrer" title="Accéder au site Picard">picard.fr</a> ou notre application.<br/>Ces coupons seront aussi disponibles directement dans votre compte client sur <a href="https://www.picard.fr/" target="_blank" rel="noopener noreferrer" title="Accéder au site Picard">picard.fr</a> ou l’application mobile, rubrique « mes avantages en cours ».',
          },
          {
            title: 'Où mes coupons sont-ils valables ?',
            content:
              'Ces coupons seront valables pour les achats effectués dans les magasins Picard Surgelés (France , Belgique et Luxembourg) le site web et l’application. Les coupons sont cumulables avec toutes les offres en cours. Ils sont utilisables séparément. La monnaie n’est pas rendue sur les coupons d’achat et ils ne sont pas sécables. Les dates de validité sont précisées sur chacun des coupons.',
          },
        ],
        accordion: {
          styles: {
            title: {
              fonSize: '18px',
              fontFamily: 'var(--font-family-medium)',
              color: '#0011AC',
              lineHeight: '22px',
              margin: '10px 0',
            },
            description: {
              fontSize: '14px',
              color: '#6B767C',
              fontFamily: 'var(--font-family)',
              lineHeight: '20px',
              margin: '5px 5px',
            },
          },
          iconMore: 'assets/images/nix/expand-more.svg',
          iconLess: 'assets/images/nix/expand-less.svg',
          alternativeTextExpandMore: 'Réduire la section',
          alternativeTextExpandLess: 'Développer la section',
        },
      },
      templateBeforeContactForm: [
        '<div style="margin: 0 auto; width: 80%;color: #3d3d3d; padding-top: 3rem;">',
        '<h1 style="font-size: 18px;font-family: var(--font-family-bold); text-align:center;">Règlement complet du Jeu « Les Défis Picard&Nous Septembre »</h1>',
        '<p style="font-size: 18px;font-family: var(--font-family-bold); text-align:center;">DU 14/09/2026 au 25/10/2026</p>',
        '<p style="font-size: 13px;margin-bottom:20px !important;font-family: var(--font-family-semi-bold); text-align:center;">EN PARTICIPANT AU JEU, VOUS ACCEPTEZ EXPRESSEMENT ET SANS RESERVE LE PRESENT REGLEMENT. SI VOUS NE SOUHAITEZ PAS ACCEPTER LE PRESENT REGLEMENT, NOUS VOUS DEMANDONS DE NE PAS PARTICIPER AU JEU.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-family: var(--font-family-bold);">Période de participation au Jeu :</span> du 14/09/2026 à partir de 00h00 au 25/10/2026 à 23H59 ;</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-family: var(--font-family-bold); font-size: 14px;">Support de participation :</span> sur le site internet : <a aria-label="Accéder à la page de mon compte Picard" title="Accéder à la page de mon compte Picard" target="_blank" href="https://www.picard.fr/on/demandware.store/Sites-picard-Site/fr_FR/Account-ShowMesDefis">https://www.picard.fr/on/demandware.store/Sites-picard-Site/fr_FR/Account-ShowMesDefis</a> ci-après le « Site »</p>',
        '<p style="font-size: 15px;margin-bottom: 15px;font-family: var(--font-family-bold);">Communication sur le Jeu :</p>',
        '<ul style="font-size: 12px;font-family: var(--font-family);">',
        '<li>Par email adressé aux clients Picard & Nous,</li>',
        '<li>En magasin Picard,</li>',
        '<li>Sur le site internet de Picard Surgelés www.picard.fr,</li>',
        '<li>Sur les comptes Facebook et Instagram de Picard Surgelés.</li>',
        '</ul>',
        '<p style="font-size: 14px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Modalités de participation au Jeu :</span> Pour participer au Jeu, le participant doit :</p>',
        '<ul style="font-size: 12px;font-family: var(--font-family);">',
        '<li>Résider en France métropolitaine, Belgique ou Luxembourg ;</li>',
        '<li>Avoir préalablement adhéré au programme fidélité Picard&Nous ;</li>',
        '<li>Avoir préalablement renseigné son adresse email personnelle au sein de son Compte Picard ;</li>',
        '<li>Lire le règlement complet du Jeu et en accepter les dispositions.</li>',
        '</ul>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le participant doit ensuite se rendre sur le Site afin de se connecter à son Compte Picard et sélectionner parmi les 10 (dix) défis qui sont proposés, le ou les défis qu’il souhaite réaliser, dans la limite de 6 (six) défis.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les défis devront être réalisés pendant la « Période de participation au Jeu ». Passé ce délai, le participant ne pourra plus participer aux défis.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">En achetant ses produits préférés sur www.picard.fr ou en magasin Picard Surgelés en France métropolitaine, Belgique ou Luxembourg, le participant fait progresser ses défis. Au fur et à mesure, il accède à des paliers qui lui permettent de cumuler des euros.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Pour suivre l’avancement de ses défis, le participant doit se rendre sur le Site accessible depuis les emails qu’il reçoit de la part de Picard&Nous ou via son Compte Picard.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Cette page est mise à jour au plus tôt le lendemain de la réalisation de son défi.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Désignation du/des gagnant(s) :</span> les gagnants sont désignés en fonction des paliers atteints à l’issue de la Période de participation au Jeu.</p>',
        '<p style="font-size: 14px;margin-bottom:5px; font-family: var(--font-family-bold);">Dotation :</p>',
        '<p style="font-size: 12px;margin-bottom:0px;font-family: var(--font-family);">En fonction du nombre de paliers atteint, un ou des bons d’achat à valoir sur tous les produits Picard dans les magasins Picard en France métropolitaine, Belgique et Luxembourg et sur le site internet www.picard.fr seront adressés au participant. La valeur des bons d’achats varie entre 1€ et 25€.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les bons d’achat sont cumulables avec toutes les offres en cours et sont utilisables séparément. La monnaie n’est pas rendue sur le(s) bon(s) d’achat. Le(s( bon(s) d’achat sont valables jusqu’à la date indiquée sur le coupon.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Obtention de la/des dotation(s) :</span> Dans un délai de dix (10) jours à l’issue du Jeu, l’Organisateur contactera par e-mail le(s) gagnant(s) pour les informer de leur gain et leur adresser le(s) bon(s) d’achat(s).<br/>Les(s) gagnant(s) pourront également retrouver leur(s) bon(s) d’achat(s) sur leur Compte Picard accessible via le site internet à l’adresse www.picard.fr et de l’application mobile « PICARD »</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Nombre de gagnant(s) :</span>  le nombre de gagnant(s) dépend du nombre de défis relevés.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Nombre de suppléant(s) :</span> 0</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Demande d’information : picardetnous@picard.fr </p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Disponibilité du règlement :</span> <a aria-label="Accéder à la page de mon compte Picard" title="Accéder à la page de mon compte Picard" target="_blank" href="https://www.picard.fr/on/demandware.store/Sites-picard-Site/fr_FR/Account-ShowMesDefis/">https://www.picard.fr/on/demandware.store/Sites-picard-Site/fr_FR/Account-ShowMesDefis</a></p>',
        '<p style="font-size: 12px;font-family: var(--font-family);"><span style="font-size: 14px;font-family: var(--font-family-bold);">Dépôt chez l’huissier :</span>Le règlement est déposé au rang des minutes de l’office LEGRAIN CESCA ET ASSOCIES, Commissaires de Justice domiciliés au 66, avenue des champs Elysées à Paris (75008).</p>',
        '<p style="font-size: 14px; margin-bottom:5px;text-decoration:underline;font-family: var(--font-family-bold);">1. ORGANISATEUR</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La société PICARD SURGELES, société par actions simplifiée (S.A.S.) au capital de 2.485.858 euros, dont le siège social est au 1 Route Militaire, 77300 Fontainebleau, immatriculée au R.C.S. de Melun sous le n° 784 939 688 (ci-après, l’ «<span style="font-size: 14px;font-family: var(--font-family-bold);"> Organisateur</span> »), organise sur le Site, un jeu (ci-après, le « Jeu »).</p>',
        '<p style="font-size: 14px; margin-bottom:5px;text-decoration:underline;font-family: var(--font-family-bold);">2. CONDITIONS DE PARTICIPATION</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La participation au Jeu implique l’acceptation expresse et sans réserve du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Ce Jeu est réservé aux personnes physiques. Pour participer, il est nécessaire de se conformer aux conditions visées dans le préambule.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Toute personne ayant participé, directement ou indirectement à l’élaboration et/ou à la gestion du Jeu (notamment les collaborateurs de l’Organisateur ou de son/ses agence(s), ou le/les partenaire(s) associé(s) au Jeu, ainsi que les membres de leurs foyers) n’est pas autorisée à participer au Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La participation doit être personnelle.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Il est formellement interdit aux participants de participer au Jeu organisée sur le Site à partir de plusieurs adresses électroniques et/ou à partir de l’adresse électronique d’un tiers. S’il est constaté qu’un participant a participé à partir de plusieurs adresses électroniques et/ou à partir de l’adresse électronique d’un tiers, le participant sera exclu du Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur se réserve le droit d’effectuer les vérifications nécessaires relatives à l’identité, l’âge, les coordonnées des participants en cas de doute raisonnable. Toute information ou participation incomplète, erronée, falsifiée, contrevenante au présent règlement ou ne permettant pas d’identifier ou de localiser le participant entraînera l’annulation de sa participation et de la dotation. Il est rigoureusement interdit, par quelque procédé que ce soit, de modifier ou de tenter de modifier les dispositifs du Jeu proposé, notamment afin d’en modifier les résultats ou d’influencer par un moyen automatisé ou déloyal la validité de la désignation d’un gagnant. S’il s’avère qu’un participant a apparemment gagné une dotation en contravention avec le présent règlement, par des moyens frauduleux, tels qu’une recherche automatisée ou l’emploi d’un algorithme, ou par des moyens autres que ceux résultant du processus décrit par l’Organisateur ou par le présent règlement, la dotation concernée ne lui serait pas attribuée et resterait propriété de l’Organisateur.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">3. MODALITES DE PARTICIPATION</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Pour participer, le participant doit se conformer aux modalités de participation décrites en préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Aucun autre moyen de participation au Jeu ne sera pris en compte.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le participant s’engage à ne pas publier, dans le cadre du Jeu, des contenus (photographies, textes, vidéos, etc.) injurieux, portant atteinte à l’honneur, diffamatoires, discriminants, haineux et/ou incitant à la haine d’une personne et/ou d’un groupe de personnes, menaçants, présentant un caractère politique ou polémique, faisant l’apologie du terrorisme, promouvant des contrefaçons ou autres produits illégaux, ou plus généralement des contenus contraires aux bonnes mœurs et à la loi.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les participants qui, en raison de leur comportement de nature à perturber le fonctionnement du Jeu ou contraire aux règles et usages en vigueur, n’auront plus accès au Jeu de l’Organisateur, et par conséquent, ne seront plus admis à participer au Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Par ailleurs, le participant garantit à l’Organisateur que le contenu publié ne porte pas atteinte aux droits de tiers, et notamment aux droits de propriété intellectuelle, de la personnalité et/ou à la vie privée d’un tiers.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les participations au Jeu seront annulées si elles sont incorrectes, incomplètes, contrefaites et/ou réalisées de manière contrevenante au présent règlement.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">4. SELECTION DU/DES GAGNANT(S)</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le(s) gagnant(s) sera(ont) désigné(s) selon les modalités définies en préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le nombre de gagnant(s) est précisé dans le préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le nombre de gagnant(s) suppléant(s) est également précisé dans le préambule du présent règlement.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">5. DOTATION(S)</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le(s) gagnant(s) se verra(ont) attribué la/les dotation(s) indiquée(s) dans le préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La dotation est nominative, non commercialisable et ne peut pas être attribuée ou cédée à un ou des tiers.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">6. OBTENTION DE(S) DOTATION(S)</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le(s) gagnant(s) obtiendra(ont) sa/leur(s) dotation(s) selon les modalités définies en préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La/les dotation(s) ne peut(vent) pas faire, à la demande d’un gagnant, l’objet d’un remboursement en espèces ou d’une contrepartie de quelque nature que ce soit, ni être remplacée par une dotation de nature équivalente.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur se réserve le droit de remplacer les dotations par des dotations de nature et de valeur équivalentes.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Dans l’hypothèse où le(s) gagnant(s) ne voudrait(ent) pas ou ne pourrait(aient) pas, pour quelque raison que ce soit, bénéficier de tout ou partie de la dotation gagnée, dans les conditions décrites dans le présent règlement, il(s) perdra(ont) le bénéfice complet de ladite/lesdites dotation(s) et ne pourra(ont) prétendre à quelconque indemnisation ou contrepartie.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur ne pourra être tenu pour responsable en cas de problèmes et/ou de détériorations intervenues pendant le transport ou l’expédition des éléments composant les dotations qui seraient envoyées par voie postale. Dans ce cas, la responsabilité du transporteur ou des sous- traitants de l’Organisateur devra être recherchée directement par le gagnant qui en fera son affaire sans recours contre l’Organisateur.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">7. COMMUNICATION DE L’IDENTITE DU/DES GAGNANT(S) ET EXPLOITATION DES ATTRIBUTS DE LA PERSONNALITE DU/DES GAGNANT(S)</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le(s) gagnant(s) autorise(nt) l’Organisateur à utiliser, quel que soit le support de diffusion, en tant que tel, son/leur image, son/ leur nom, prénom, adresse (ville, département, région, pays), sans que cela ne confère une rémunération, un droit, ou un avantage quelconque, autre que l’attribution de la/leur(s) dotation(s) et ce pendant une durée de 6 mois à compter de la remise de leur dotation en France, Belgique, Luxembourg et dans le monde entier (compte tenu de la spécificité d’Internet) et ce sans que cette utilisation puisse ouvrir d’autres droits que la/les dotation(s) gagnée(s).</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Une autorisation d’exploitation des attributs de la personnalité du/des gagnant(s) pourra être régularisée à la fin du Jeu.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">8. DONNEES PERSONNELLES</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur est amené à collecter et traiter des données à caractère personnel des participants dans le cadre du Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Ces données sont traitées aux fins d’exécution du contrat afin de pouvoir adresser aux gagnants leur dotation, effectuer le suivi de l’envoi de la dotation et gérer les éventuelles réclamations.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les données sont destinées à l’Organisateur et pourront être communiquées aux sous-traitants et éventuels partenaires de l’Organisateur pour les stricts besoins du Jeu, et notamment pour l’envoi des dotations.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Les données personnelles collectées seront conservées pour la durée nécessaire à l’accomplissement de l’objectif poursuivi lors de la collecte.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Conformément au RGPD (UE) 2016/679 du 27 avril 2016, vous disposez d’un droit d’accès et d’un droit de rectification des données vous concernant et, s’ils sont applicables, d’un droit de suppression, d’un droit à l’effacement et à la limitation du traitement ainsi que d’un droit à la portabilité de vos données. Vous disposez également du droit de définir des directives relatives au sort de vos données après votre décès.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Si vous souhaitez exercer l’un des droits précités, vous pouvez adresser votre demande à tout moment en nous contactant via notre formulaire dédié, disponible sur notre site, notamment au sein de notre Politique de Confidentialité ou en nous écrivant :</p>',
        '<ul>',
        '<li style="font-size: 12px;font-family: var(--font-family);"><span style="font-family: var(--font-family-bold);">Pour la France :</span> par courrier postal adressé au Délégué à la Protection des Données de Picard à l’adresse suivante : Picard surgelés - 12 boulevard Garibaldi – 92130 Issy les Moulineaux</li>',
        '<li style="font-size: 12px;font-family: var(--font-family);"><span style="font-family: var(--font-family-bold);">Pour la Belgique et le Luxembourg :</span> par courrier postal à l’adresse suivante : Avenue Louise 523 – 1050 Bruxelles.</li>',
        '</ul>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Si vous exercez l’un de ces droits par voie électronique, les Données vous seront fournies, le cas échéant, par voie électronique lorsque cela est possible, sauf à ce que vous ayez demandé spécifiquement qu’il en soit autrement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">À tout moment ils disposent du droit d’introduire une réclamation auprès de la CNIL pour la France, auprès de la commission de la vie privée pour la Belgique ou auprès de la commission nationale pour la protection des données pour le Luxembourg.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">En cas d’exercice du droit de suppression ou d’opposition, du droit à l’effacement et à la limitation de traitement avant la fin des défis, les participants renoncent à leur participation et, le cas échéant, à potentiellement obtenir leur dotation.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">9. RESPONSABILITE</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur ne saurait être tenu pour responsable d’éventuels dysfonctionnements liés au réseau Internet lui-même ou liés à toute intrusion, tentative d’intrusion, fraude, bogue, défaillance technique ou tout autre motif dépassant le contrôle de l’Organisateur et ayant entraîné des défaillances dans l’administration, la sécurité, l’équité, l’intégrité ou la gestion du défi. L’Organisateur ne saurait notamment être déclaré responsable pour toutes erreurs, omissions, interruptions, effacement, et plus généralement, de la perte de toute donnée pendant la participation au Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur se réserve le droit de modifier le Jeu en raison d’événements indépendants de sa volonté.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur pourra décider de modifier le Jeu s’il apparaît que des fraudes manifestes sont intervenues sous quelque forme que ce soit, notamment de manière informatique dans le cadre de la participation au Jeu ou de la détermination des attributions des bons d’achat.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">10. DEMANDE D’INFORMATION</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Toute demande d’information relative au Jeu devra être envoyée à l’adresse indiquée en préambule du présent règlement.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">11. LITIGES/ATTRIBUTION DE JURIDICTION</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Toute demande concernant l’interprétation du règlement du Jeu doit parvenir par écrit à l’adresse suivante : Service Communication, 12 boulevard Garibaldi – 92130 Issy les Moulineaux. Il ne sera répondu à aucune demande concernant l’interprétation du présent règlement qui parviendra chez l’Organisateur plus de 15 jours après la fin du Jeu.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">La loi applicable au présent règlement est la loi française.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Tout différend, non prévu par le présent règlement, né à l’occasion de ce Jeu, fera l’objet d’une tentative de règlement amiable.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">A défaut, le litige sera soumis à la compétence des juridictions du ressort de la Cour d’Appel de Paris.</p>',
        '<p style="font-size: 14px; margin-bottom:5px; text-decoration:underline; font-family: var(--font-family-bold);">12. DISPONIBILITE DU PRESENT REGLEMENT</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">Le présent règlement peut être consulté gratuitement à l’endroit précisé dans le préambule du présent règlement.</p>',
        '<p style="font-size: 12px;font-family: var(--font-family);">L’Organisateur se réserve le droit de modifier le présent règlement du Jeu à tout moment.</p>',
        '</div>',
      ],
      extraLinks: [
        {
          title: {
            text: "Besoin d'aide ?",
            fontFamily: 'var(--font-family-bold)',
          },
          link: {
            color: 'white',
            label: 'Cliquez ici',
            fontFamily: 'var(--font-family)',
            backgroundColor: '#0710AC',
            href: 'https://www.picard.fr/picard-a-votre-service/service-info-consommateur/',
          },
        },
      ],
    },
    currentChallenges: {
      meta: {
        title: 'Défis Picard | Picard',
        keywords:
          "picard, surgelés, défis, challenge, gagner, bon d'achat, fidélité, picard&nous",
        description:
          "Participez aux défis Picard et gagnez des bons d'achat à valoir sur tous les produits Picard dans les magasins Picard en France métropolitaine, Belgique et Luxembourg et sur le site internet www.picard.fr.",
      },
      howDoesitWork: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        backgroundColor: '#0112AC',
        containerBackgroundColor: 'white',
        text: 'Comment ça marche ?',
        borderRadius: '5px',
        containerPadding: '2rem 0 0',
        marginBottom: '2rem',
        modal: {
          background: '#FFFFFF',
          title: {
            text: 'Comment ça marche ?',
            color: '#000000',
            fontFamily: 'var(--font-family-bold)',
          },
          closeButton: {
            imageUrl: 'assets/images/default/close-button.svg',
            alternativeText: 'Fermer le tutoriel',
            color: 'var(--challenge-primary-color)',
          },
          skipNowButton: {
            text: "Passer pour l'instant",
            color: 'white',
            fontFamily: 'var(--font-family-bold)',
            backgroundColor: '#0112AC',
            borderRadius: '5px',
          },
        },
      },
      howToPlay: {
        specificDisplayCondition: DISPLAY_CONDITION.DEFAULT,
        title: {
          color: '#0710AC',
          text: 'Comment ça marche ?',
          fontFamily: 'var(--font-family-semi-bold)',
        },
        templateHowToPlay: {
          mobile: [
            '<div style="text-align: center; font-size: 4.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
            '* sous la forme de coupons',
            '</div>',
          ],
          tablet: [
            '<div style="text-align: center; font-size: 2.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
            '* sous la forme de coupons',
            '</div>',
          ],
          desktop: [
            '<div style="text-align: center; font-size: 1.5vw;padding: 10px 55px;color: #0710AC; font-style: italic; font-family: var(--font-family-medium)">',
            '* sous la forme de coupons',
            '</div>',
          ],
        },
      },
      background: '#F5F5F5',
      upButton: {
        backgroundColor: '#0011AC',
        content: '^',
      },
      templateAfterChallenges: {
        mobile: [
          '<div style=" margin: 20px auto;text-align: center;">',
          '<p style="color:#0710AC;margin-bottom: 0;font-style: italic;font-family:var(--font-family-medium); font-size: 4.5vw;">* sous la forme de coupons </p>',
          '</div>',
        ],
        tablet: [
          '<div style=" margin: 20px auto;text-align: center;">',
          '<p style="color:#0710AC;margin-bottom: 0;font-style: italic; font-family:var(--font-family-medium); font-size: 3.5vw;">* sous la forme de coupons </p>',
          '</div>',
        ],
        desktop: [
          '<div style=" margin: 20px auto;text-align: center;">',
          '<p style="color:#0710AC;margin-bottom: 0; font-style: italic;font-family:var(--font-family-medium); font-size: 1.9vw;">* sous la forme de coupons </p>',
          '</div>',
        ],
      },
      templateBeforeChallenges: {
        mobile: [
          '<div style="text-align: center; border-radius: 10px; padding: 10px; background-color: #0011AC; color: white; margin: 0 6vw 30px">',
          "<div style='font-size: 13px;font-family: WorksSan-SemiBold;'>La campagne de défis est terminée. Merci pour votre participation et félicitations aux gagnants ! Vos coupons seront bientôt disponibles dans « Mes avantages en cours ». <br/>Une nouvelle campagne se prépare… à très vite pour de nouveaux défis !</div>",
          '</div>',
        ],
        tablet: [
          '<div style="text-align: center;  border-radius: 10px; padding: 10px; background-color: #0011AC; color: white; margin-bottom: 30px">',
          "<div style='font-size: 13px;font-family: WorksSan-SemiBold;'>La campagne de défis est terminée. Merci pour votre participation et félicitations aux gagnants ! Vos coupons seront bientôt disponibles dans « Mes avantages en cours ». <br/>Une nouvelle campagne se prépare… à très vite pour de nouveaux défis !</div>",
          '</div>',
        ],
        desktop: [
          '<div style="text-align: center; border-radius: 10px; padding: 10px; background-color: #0011AC; color: white; margin: 0 auto 50px; max-width: 900px">',
          "<div style='font-size: 15px;font-family: WorksSan-SemiBold;'>La campagne de défis est terminée. Merci pour votre participation et félicitations aux gagnants ! Vos coupons seront bientôt disponibles dans « Mes avantages en cours ». <br/>Une nouvelle campagne se prépare… à très vite pour de nouveaux défis !</div>",
          '</div>',
        ],
      },
    },

    sorry: {
      background: '#F2F2F2',
      content: [
        '<div style="margin-bottom: 1rem;"><img src="assets/images/nix/retailer-logo.webp" alt="Logo Picard"></div>',
        '<div style="font-size: 1.5rem; text-align: center; color: #0710ac; font-family: var(--font-family-medium);">Merci pour votre inscription</div>',
        '<div style="font-size: 1.5rem; text-align: center; color: #0710ac; font-family: var(--font-family-medium);">Connectez-vous dès demain pour choisir vos Défis Picard !</div>',
      ],
    },
  },
  components: {
    header: {
      variant: Variants.VARIANT_8,
      backgroundColor: '',
      bannerAlternativeText:
        'Choisissez vos défis pour célébrer le bon à petits prix',
      backgroundImage: {
        mobile: {
          imageUrl: 'assets/images/nix/cover-mobile.webp',
        },
        tablet: {
          imageUrl: 'assets/images/nix/cover-mobile.webp',
        },
        desktop: {
          imageUrl: 'assets/images/nix/cover-desktop.webp',
        },
      },
      dates: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        text: 'Du {startDate} au {endDate}',
      },
      roundel: {
        imageUrl: 'assets/images/nix/mobile-roundel.webp',
        alternativeText: 'Jusqu’à 25€ à gagner',
      },
      headLine: {
        color: '#FE3801',
        text: 'Ciblez vos défis',
        fontFamily: 'var(--font-family-bold)',
      },
      subHeadLine: {
        color: '#0710AC',
        text: 'et faites des \n économies !',
        fontFamily: 'var(--font-family-bold)',
      },
      win: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        upTo: '25€',
        earn: 'à gagner',
        coupons: 'Sous forme de \n coupons',
      },
    },
    brands: {
      variant: Variants.VARIANT_1,
      brandsBgColor: '',
      alternativeText: '',
    },
    footer: {
      variant: Variants.VARIANT_1,
      mobileVisiblity: false,
      styles: {
        padding: '30px 0',
        textAlign: 'center',
        backgroundColor: '#0710AC',
      },
      linkStyles: {
        color: 'white',
        fontSize: '16px',
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontFamily: 'var(--font-family)',
      },
      links: [
        {
          url: 'help',
          label: 'FAQ',
        },
        {
          url: 'help',
          fragment: 'terms',
          label: 'Règlement',
        },
      ],
    },
    tutorial: {
      background: '#F2F3FB',
      carousel: {
        config: {
          sectionAriaLabel: 'Carrousel du tutoriel',
          controlsAriaLabel: 'Contrôles du carrousel',
          paginationAriaLabel: 'Indicateurs de diapositives',
          title: {
            fontSize: '18px',
            color: '#0710AC',
            fontFamily: 'var(--font-family-semi-bold)',
            text: "Cagnottez jusqu'à 25€ sur votre carte Picard&Nous en relevant vos défis préférés !",
          },
          dots: {
            inactiveBg: '#B4B7E6',
            activeBg: 'var(--challenge-primary-color)',
            ariaLabel: 'Aller à la diapositive {variable} de {variable}',
          },
          slideIndicatorLabel: 'Diapositive {variable} sur {variable}',
          controls: {
            leftIcon: {
              imageUrl: 'assets/images/nix/chevron-left.svg',
              alternativeText: 'Aller à la diapositive précédente',
            },
            rightIcon: {
              imageUrl: 'assets/images/nix/chevron-right.svg',
              alternativeText: 'Aller à la diapositive suivante',
            },
          },
        },
        items: {
          variant: Variants.VARIANT_5,
          styles: {
            title: {
              color: '#0710AC',
              fontFamily: 'var(--font-family-semi-bold)',
            },
            card: {
              border: 'none',
              borderRadius: '16px',
              background: 'white',
              boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 7px 0px',
            },
          },
          steps: [
            {
              title:
                '1 : Je sélectionne mes 6 défis préférés parmi les 10 proposés !',
              picture: {
                imageUrl: 'assets/images/nix/step-1.webp',
                alternativeText:
                  'Sélection des {variable} défis préférés parmi les 10 proposés',
              },
            },
            {
              title: '2 : Je présente ma carte Picard&Nous lors de mes achats',
              picture: {
                imageUrl: 'assets/images/nix/step-2.webp',
                alternativeText:
                  'Présentation de la carte Picard&Nous lors des achats',
              },
            },
            {
              title: '3 : Je gagne jusqu’à 25€ sur ma carte Picard&Nous',
              picture: {
                imageUrl: 'assets/images/nix/step-3.webp',
                alternativeText: 'Gagner jusqu’à 25€ sur la carte Picard&Nous.',
              },
            },
          ],
        },
      },
      borderBottom: '3px solid #0710AC',
    },
    wallet: {
      variant: Variants.VARIANT_2,
      fontStyle: 'italic',
      backgroundColor: '#0011AC',
      label: {
        color: 'white',
        fontSize: '9px',
        lineHeight: '20px',
        text: 'Ma cagnotte:',
        fontFamily: 'var(--font-family-semi-bold)',
      },
      amount: {
        color: 'white',
        fontFamily: 'var(--font-family-semi-bold)',
      },
    },
    navbar: {
      variant: Variants.VARIANT_1,
      navbarFullWidth: true,
      menuVariant: Variants.VARIANT_1,
      hasLayoutPaddingTop: false,
      dropdownLabel: 'AIDE',
      fontFamily: 'var(--font-family-semi-bold)',
      openButton: {
        imageUrl: 'assets/images/nix/menu-selected.svg',
        buttonTitle: 'Accédez aux options du site',
        imageAlt: 'Accédez aux options du site',
      },
      logo: {
        url: 'current',
        height: '80px',
        imageUrl: 'assets/images/nix/retailer-logo.webp',
        alternativeText: 'Picard logo',
      },
      items: [
        {
          url: 'current',
          label: 'MES DÉFIS',
          ariaLabel: 'Accéder à la page de mes défis en cours',
          menuIcon: {
            imageUrl: 'assets/images/nix/home.svg',
            alternativeText: 'Icône Accueil',
          },
          iconUrlSelected: {
            imageUrl: 'assets/images/nix/home-selected.svg',
            alternativeText: 'Icône Accueil sélectionnée',
          },
          displayOn: [NavbarItemLocation.DESKTOP, NavbarItemLocation.MOBILE],
        },
        {
          url: 'help',
          label: 'AIDE',
          ariaLabel: 'Accéder à la page d’aide',
          menuIcon: {
            imageUrl: 'assets/images/nix/help.svg',
            alternativeText: 'Icône Aide',
          },
          iconUrlSelected: {
            imageUrl: 'assets/images/nix/help-selected.svg',
            alternativeText: 'Icône Aide sélectionnée',
          },
          displayOn: [NavbarItemLocation.DESKTOP],
        },
        {
          url: 'help',
          ariaLabel: 'Accéder à la page d’aide',
          label: 'FAQ',
          external: false,
          displayOn: [NavbarItemLocation.DROPDOWN],
        },
        {
          url: 'help',
          ariaLabel: 'Accéder au règlement des Mes Défis',
          label: 'Règlement',
          external: false,
          fragment: 'terms',
          displayOn: [NavbarItemLocation.DROPDOWN],
        },
      ],
    },
    countdown: {
      variant: Variants.VARIANT_2,
      backgroundColor: '#0011AC',
      showOnPages: 'all',
      labelStyle: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
      },
      title: {
        color: 'white',
        label: 'Fin du jeu dans',
        fontFamily: 'var(font-family-semi-bold)',
      },
      numberStyle: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
      },
      texts: {
        days: 'j',
        hours: 'h',
        minutes: 'm',
        seconds: 's',
      },
    },
    challenges: {
      elements: {
        winCard: {
          variant: Variants.VARIANT_4,
          backgroundColor: '#FF8300',
          left: {
            backgroundImage: {
              imageUrl: 'assets/images/nix/reward.svg',
              alternativeText:
                'Félicitations ! Vous avez gagné {variable}€ en terminant ce défi !',
            },
            amount: {
              color: 'white',
              fontFamily: 'var(--font-family-bold)',
              fontStyle: 'italic',
            },
          },
          right: {
            winFirstLabel: {
              text: 'Félicitations,',
              color: 'white',
              fontFamily: 'var(--font-family-bold)',
            },
            winSecondLabel: {
              text: 'vous avez gagné !',
              color: 'white',
              fontFamily: 'var(--font-family-bold)',
            },
          },
        },
        selectionButton: {
          variant: Variants.VARIANT_3,
          buttonCatchPhrase: {
            buttonLabel: 'SÉLECTIONNER CE DÉFI',
            buttonBorderRadius: '5px',
            buttonFontFamily: 'var(--font-family)',
            buttonColor: 'white',
            buttonBackgroundColor: '#0112AC',
          },
          catchPhrase: {
            collectUpTo: {
              label: "Gagnez <br> jusqu'à",
              fontFamily: 'var(--font-family-semi-bold',
              fontSize: '13px',
            },
            selectImage: {
              imageUrl: 'assets/images/nix/reward.svg',
              alternativeText:
                'Sélectionnez ce défi et gagnez jusqu’à {variable}€',
            },
            amountFontFamily: 'var(--font-family-semi-bold)',
            amountFontStyle: 'italic',
            amountColor: '#FFFFFF',
          },
        },
        unselectionButton: {
          variant: Variants.VARIANT_1,
          icon: {
            imageUrl: 'assets/images/nix/cancel.svg',
            alternativeText: 'Annuler ce défi',
          },
        },
        outOfStock: {
          variant: Variants.VARIANT_1,
          backgroundColor: 'rgba(15, 50, 80, 0.65)',
          borderRadius: '16px',
          banner: {
            border: '2px solid white',
            textColor: 'white',
            borderRadius: '2px',
            backgroundColor: '#DB3832',
            text: 'No more challenges',
            fontFamily: 'var(--font-family-bold)',
          },
        },
      },
      step: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_3,
          bannerAlternativeText: 'Bannière des défis',
          logoAlternativeText: 'Bannière du logo',
          selectionButtonbackgroundColor: 'white',
          header: {
            height: '93px',
            backgroundColor: '#FFFFFF',
            additionalInfo: {
              color: 'white',
              backgroundColor: '#3F07F1',
              specialBackgroundColor: '#FF8300',
              fontFamily: 'var(--font-family-semi-bold)',
            },
          },
          subHeader: {
            color: '#272F35',
            backgroundColor: 'white',
            completedBackgroundColor: '#FF8300',
            fontFamily: 'var(--font-family)',
            fontSize: '11px',
            icon: {
              title: 'En savoir plus',
              displayWhenSelected: false,
              imageUrl: 'assets/images/nix/info.svg',
              alternativeText: 'Cliquez pour vérifier les produits éligibles',
            },
          },
          body: {
            progressbar: {
              earnLabel: 'Je gagne',
              spendLabel: 'Je dépense',
              labelColor: '#0011AC',
              progressBarLeft: '65px',
              progressColor: '#0011AC',
              containerColor: '#D2D2D2',
              labelFontFamily: 'var(--font-family-medium)',
              pictureStageReached: {
                imageUrl: 'assets/images/nix/picture-reached.svg',
                alternativeText:
                  'Étape atteinte : Marquer cette étape comme complétée',
              },
            },
            rewards: {
              color: '#4600FB',
              fontStyle: 'italic',
              fontSize: '13px',
              fontFamily: 'var(--font-family-bold)',
              backgroundColors: {
                bubbleWidth: '50px',
                bubbleHeight: '58px',
                reached: { fill: '#4600FB', stroke: '', textColor: 'white' },
                unreached: {
                  fill: 'white',
                  stroke: '#4600FB',
                  textColor: '#4600FB',
                },
                default: {
                  fill: '#F2F2F2',
                  stroke: '#F2F2F2',
                  textColor: '#bababa',
                },
                backgroundImage: 'assets/images/nix/max-reward.svg',
                alternativeText: {
                  reached: ' J’ai gagné {variable}€',
                  default: 'J’ai gagné {variable}€',
                  unreached: 'Je gagne {variable}€',
                },
              },
            },
            targets: {
              color: '#0011AC',
              fontFamily: 'var(--font-family-medium)',
            },
          },
          footer: {
            color: '#0011AC',
            label: 'J’ai dépensé',
            fontFamily: 'var(--font-family)',
            icon: {
              imageUrl: 'assets/images/nix/shop.svg',
              alternativeText: 'Icône de panier',
            },
            spentAmountFontFamily: 'var(--font-family-bold)',
          },
        },
      },
      frequency: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_1,
          header: {
            backgroundImage: {
              url: 'assets/images/nix/visit-banner.webp',
              bannerAriaLabel:
                '{variable} visites en magasin Picard et c’est gagné.',
              title: {
                color: 'white',
                text: 'Défi visites magasin',
                fontFamily: 'var(--font-family-semi-bold)',
              },
              subTitle: {
                color: 'white',
                text: "{variable} {visite|visites}<br/> en magasin Picard<br/> et c'est gagné.", // Use {singular|plural}; pipe picks the form
                fontFamily: 'var(--font-family-semi-bold)',
              },
            },
            height: '118px',
          },
          subHeader: {
            borderBottom: '1px solid #f4f5f6',
            completedBackgroundColor: '#FF8300',
            backgroundColor: 'white',
            title: {
              color: '#272F35',
              fontFamily: 'var(--font-family)',
              label: 'Montant minimum de {variable}€ par passage en caisse',
            },
            picture: {
              imageUrl: 'assets/images/nix/info.svg',
              alternativeText:
                'Cliquez ici pour lire les informations sur le défi fréquence',
            },
          },
          body: {
            stamps: {
              showNumbers: false,
              iconSelected: 'assets/images/nix/frequency-stamp-success.svg',
              iconNonSelected: 'assets/images/nix/frequency-stamp-empty.svg',
            },
            rewardRatio: {
              rewardPicture: {
                imageUrl: 'assets/images/nix/frequency-max-reward.svg',
                alternativeText: '',
              },
              fontFamily: 'var(--font-family-semi-bold)',
              color: '#4600FB',
            },
          },
          footer: {
            color: '#0011AC',
            label: 'Mes visites:',
            fontFamily: 'var(--font-family)',
            footerIcon: {
              imageUrl: 'assets/images/nix/shop.svg',
              alternativeText: '',
            },
          },
        },
        [NixSubType.LAD]: {
          variant: Variants.VARIANT_1,
          header: {
            backgroundImage: {
              url: 'assets/images/nix/livraisons-visit-banner.webp',
              bannerAriaLabel: '{variable} livraisons et c’est gagné',
              title: {
                color: 'white',
                text: 'Livraison à domicile',
                fontFamily: 'var(--font-family-bold)',
              },
              subTitle: {
                color: '#3F07F1',
                text: '{variable} {livraison|livraisons} <br/> et c’est gagné.', // Use {singular|plural}; pipe picks the form
                fontFamily: 'var(--font-family-bold)',
              },
            },
            height: '118px',
          },
          subHeader: {
            borderBottom: '1px solid #f4f5f6',
            completedBackgroundColor: '#FF8300',
            backgroundColor: 'white',
            title: {
              color: '#272F35',
              fontFamily: 'var(--font-family)',
              label: 'Minimum de {variable}€ (hors frais de port) par commande',
            },
            picture: {
              imageUrl: 'assets/images/nix/info.svg',
              alternativeText:
                'Cliquez ici pour lire les informations sur le défi fréquence',
            },
          },
          body: {
            stamps: {
              showNumbers: false,
              iconSelected:
                'assets/images/nix/frequency-livraison-stamp-success.webp',
              iconNonSelected:
                'assets/images/nix/frequency-livraison-stamp-empty.webp',
            },
            rewardRatio: {
              rewardPicture: {
                imageUrl: 'assets/images/nix/frequency-max-reward.svg',
                alternativeText: '',
              },
              fontFamily: 'var(--font-family-semi-bold)',
              color: '#4600FB',
            },
          },
          footer: {
            color: '#0011AC',
            label: 'Mes livraisons:',
            fontFamily: 'var(--font-family)',
            footerIcon: {
              imageUrl: 'assets/images/nix/livraison-footer-icon.webp',
              alternativeText: '',
            },
          },
        },
        [NixSubType.CAC]: {
          variant: Variants.VARIANT_1,
          header: {
            backgroundImage: {
              url: 'assets/images/nix/click&collect-visit-banner.webp',
              bannerAriaLabel: '{variable} commandes et c’est gagné !',
              title: {
                color: 'white',
                text: 'Click&Collect',
                fontFamily: 'var(--font-family-bold)',
              },
              subTitle: {
                color: '#3F07F1',
                text: '{variable} {commande|commandes} <br/> et c’est gagné !', // Use {singular|plural}; pipe picks the form
                fontFamily: 'var(--font-family-bold)',
              },
            },
            height: '118px',
          },
          subHeader: {
            borderBottom: '1px solid #f4f5f6',
            completedBackgroundColor: '#FF8300',
            backgroundColor: 'white',
            title: {
              color: '#272F35',
              fontFamily: 'var(--font-family)',
              label: 'Montant minimum de {variable}€ par commande',
            },
            picture: {
              imageUrl: 'assets/images/nix/info.svg',
              alternativeText:
                'Cliquez ici pour lire les informations sur le défi fréquence',
            },
          },
          body: {
            stamps: {
              showNumbers: false,
              iconSelected:
                'assets/images/nix/frequency-click&collect-stamp-success.webp',
              iconNonSelected:
                'assets/images/nix/frequency-click&collect-stamp-empty.webp',
            },
            rewardRatio: {
              rewardPicture: {
                imageUrl: 'assets/images/nix/frequency-max-reward.svg',
                alternativeText: '',
              },
              fontFamily: 'var(--font-family-semi-bold)',
              color: '#4600FB',
            },
          },
          footer: {
            color: '#0011AC',
            label: 'Mes commandes:',
            fontFamily: 'var(--font-family)',
            footerIcon: {
              imageUrl: 'assets/images/nix/click&collect-footer-icon.webp',
              alternativeText: '',
            },
          },
        },
      },
    },
    challengeSummary: {
      variant: Variants.VARIANT_3,
      title: {
        color: '#0710AC',
        text: 'Vos défis personnalisés',
        fontFamily: 'var(--font-family-semi-bold)',
      },
      update: {
        color: '#0710AC',
        text: 'MIS À JOUR LE {variable}',
        fontFamily: 'var(--font-family-medium)',
        dateFormat: 'dd/MM/yyyy',
      },
      borderRadius: '10px',
      border: 'none',
      challengeLabels: {
        onGoingLabel: {
          color: '#0710AC',
          backgroundColor: 'white',
          text: 'défi(s) sélectionné(s)',
          fontFamily: 'var(--font-family)',
        },
        completedLabel: {
          color: '#0710AC',
          backgroundColor: 'white',
          text: 'défi(s) terminé(s)',
          fontFamily: 'var(--font-family)',
        },
      },
      challengesInfos: {
        fontFamily: 'var(--font-family-semi-bold)',
      },
    },
    modals: {
      closeButton: {
        label: 'Fermer',
        textColor: 'white',
        borderRadius: '5px',
        backgroundColor: 'var(--challenge-primary-color)',
        fontFamily: 'var(--font-family)',
        ariaLabel: 'Fermer',
      },
      unselectChallenge: {
        backgroundColor: '#FFFFFF',
        header: {
          logo: {
            alternativeText: 'Bannière de la marque',
          },
          backgroundColor: 'var(--challenge-primary-color)',
          backgroundImage: '',
        },
        frequencyHeaderImages: {
          [SubType.DEFAULT]: {
            imageUrl: 'assets/images/nix/frequency-header-default.webp',
            alternativeText: 'défi de fréquence',
          },
          [NixSubType.CAC]: {
            imageUrl: 'assets/images/nix/frequency-header-click&collect.webp',
            alternativeText: 'défi de fréquence',
          },
          [NixSubType.LAD]: {
            imageUrl: 'assets/images/nix/frequency-header-livraison.webp',
            alternativeText: 'défi de fréquence',
          },
        },
        title: {
          color: '#0710AC',
          fontFamily: 'var(--font-family-bold)',
          label: 'Etes vous sur de vouloir<br/> déselectionner ce défi ? ',
        },
        body: {
          color: '#333333',
          fontFamily: 'var(--font-family)',
          label:
            ' Pas de problème vous pourrez le<br/> sélectionner de nouveau si vous<br/> changez d’avis.',
        },

        actionButtons: {
          variant: Variants.VARIANT_2,
          confirmButton: {
            borderRadius: '5px',
            textColor: '#FFFFFF',
            backgroundColor: '#FF8300',
            label: 'OUI',
            fontFamily: 'var(--font-family)',
            ariaLabel: 'OUI',
          },
          closeButton: {
            label: 'NON',
            borderRadius: '5px',
            textColor: 'white',
            backgroundColor: '#0112AC',
            fontFamily: 'var(--font-family)',
            ariaLabel: 'NON',
          },
        },
      },
      visitInfo: {
        backgroundColor: '#FFFFFF',
        bodyBySubType: {
          [SubType.DEFAULT]: {
            color: '#6b767c',
            label:
              'Nombre d’achats à réaliser chez Picard en magasin pendant la période de la campagne (à condition de {variable}€ d’achat minimum et d’un achat par jour maximum)',
            fontFamily: 'var(--font-family)',
          },
          [NixSubType.CAC]: {
            color: '#6b767c',
            label:
              'Nombre d’achats à réaliser chez Picard en Click & Collect pendant la période de la campagne (à condition de {variable}€ d’achat minimum et d’un achat par jour maximum)',
            fontFamily: 'var(--font-family)',
          },
          [NixSubType.LAD]: {
            color: '#6b767c',
            label:
              'Nombre d’achats à réaliser chez Picard en livraison à domicile pendant la période de la campagne (à condition de {variable}€ d’achat minimum et d’un achat par jour maximum)',
            fontFamily: 'var(--font-family)',
          },
        },
      },
      productCheck: {
        ariaLabel: '',
        backgroundColor: '#FFFFFF',
        fontFamily: 'var(--font-family)',
        tabs: [
          {
            type: ProductCheckTabType.PRODUCT_LIST,
            label: '',
            searchable: true,
            inputPlaceholder: 'Saisissez un code-barres',
            tableTitle: {
              text: 'Liste des produits éligibles',
              color: 'var(--challenge-primary-color)',
            },
            columns: {
              name: {
                header: 'Produit',
                color: 'var(--challenge-primary-color)',
                fontFamily: 'var(--font-family)',
              },
              code: {
                header: 'Code barre',
                color: 'var(--challenge-primary-color)',
                fontFamily: 'var(--font-family)',
              },
            },
          },
        ],
      },
      firstSelection: {
        backgroundColor: 'white',
        title: {
          color: '#0710ac',
          label: '',
          fontFamily: 'var(--font-family-bold)',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/nix/first-selection.svg',
            alternativeText: 'Vous avez sélectionné le premier défi',
          },
        },
        body: {
          color: '#333333',
          fontFamily: 'var(--font-family)',
          label:
            'Vous venez de sélectionner votre 1er défi! Il vous reste 5 défis à sélectionner.',
        },
      },
      lastSelection: {
        backgroundColor: 'white',
        title: {
          color: '#0710ac',
          fontFamily: 'var(--font-family-bold)',
          label: 'Félicitations !',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/nix/last-selection.svg',
            alternativeText:
              'Félicitations ! Vous avez sélectionné vos {variable} défis. Atteignez les objectifs pour gagner des récompenses.',
          },
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Vous avez sélectionné vos {variable}  défis! Atteignez les objectifs pour gagner les récompenses !',
        },
      },
      maximumSelection: {
        backgroundColor: 'white',
        title: {
          color: '#0710ac',
          fontFamily: 'var(--font-family-bold)',
          label: 'Félicitations !',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/nix/maximum-selection.svg',
            alternativeText:
              'Félicitations ! Vous avez déjà sélectionné {variable} défis !',
          },
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label: 'Vous avez déjà sélectionné {variable} défis !',
        },
      },
      outOfStockIssue: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Limite atteinte',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Ce défi a atteint le nombre maximal de participants. Veuillez en choisir un autre.',
        },
      },
      genericError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Erreur',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Une erreur est survenue et le défi n’a pas pu être sélectionné. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      timeoutError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Délai dépassé',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'La sélection du défi a pris trop de temps. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      challengeUnavailable: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Campagne terminée',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Cette campagne est terminée, les défis ne sont plus disponibles à la sélection.',
        },
      },
    },
  },
};
